import { api } from "../api";

export const getSlots = function(lockerId, callback) {
  console.log(lockerId)
  const URL = `/lockers/${lockerId}/slots`;

  api
    .get(URL)
    .then((response) => {
      console.log(response)
      callback(replaceIdCaracter(response.data.data));
    })
    .catch((error) => {
      console.log("DEU ERRRO");
      console.log("Error: getSlots . " + error);
      callback([]);
    });
};

export const getSlotsAsync = async (lockerId) => {
  try {
    const url = `/lockers/${lockerId}/slots`;

    let response = await api.get(url);
    return response.data.data.slots ? response.data.data.slots : [];
  } catch (error) {
    console.log("Error: getSlotsAsync . " + error);
  }
};

export const getSlotById = function(lockerId, slotId, callback) {
  const URL = `/lockers/${lockerId}/slots/${slotId}`;

  api
    .get(URL)
    .then((response) => {
      callback(replaceIdCaracter(response.data.data));
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. getSlotById " + error);
    });
};

export const deleteSlot = function(lockerId, slotId, callback) {
  const URL = `/lockers/${lockerId}/slots/${slotId}`;
  console.log(URL);
  api
    .delete(URL)
    .then((response) => {
      callback(response.status);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. deleteSlot " + error);
    });
};

export const getLastOrdersSlot = function(lockerId, slotId, callback) {
  const URL = `/orders?filter[lockerId]=${lockerId}&filter[slotId]=${slotId}`;

  api
    .get(URL)
    .then((response) => {
      callback(replaceIdCaracter(response.data.data));
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. getLastOrdersSlot " + error);
    });
};

export const updateSlot = function(slot, callback) {
  const URL = `/lockers/${slot.lockerId}/slots/${slot.id}`;

  let data = {
    name: slot.slotName,
    status: slot.status,
    size: slot.size,
    label: slot.label,
    pne: slot.pne,
    deviceCondition: slot.deviceCondition,
  };

  api
    .put(URL, data)
    .then((response) => {
      
      callback(response.data.newSlot);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. updateSlot " + error);
    });
};

export const createSlot = function(lockerId, data, callback) {
  const URL = `/lockers/${lockerId}/slots`;

  api
    .post(URL, data)
    .then((response) => {
      callback(response.status);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. createSlot " + error);
    });
};

// export const openSlot = function(lockerId, slotId, label, slotName, user, callback) {
//   const URL = `/open-slot/rabbit`;

//   let data = {
//     lockerId: lockerId,
//     slotId: slotId,
//     label: label,
//     slotName: slotName,
//     user: user
//   };

//   console.log("DATA OPEN SLOT", JSON.stringify(data));

//   api
//     .post(URL, data)
//     .then((response) => {
//       callback(response.status);
//     })
//     .catch((error) => {
//       callback(null);
//       console.log("Error:. openSlot " + error);
//     });
// };

export const openSlot = function(lockerId, slotId, label, slotName, user, callback) {
  // const user = JSON.parse(localStorage.getItem("user"));
  // api.defaults.headers.authorization = `Bearer ${user.token}`;
  const URL = `/rabbit/send-command`;



  let data = {
    lockerId: lockerId,
    payload: {
      CMD: "OPEN_PORT_REMOTELY",
      slotId: slotId,
      label: label,
      slotName: slotName,
      user: user
    }
  };

  // console.log("DATA OPEN SLOT", JSON.stringify(data));

  api
    .post(URL, data)
    .then((response) => {
      callback(response.status);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. openSlot " + error);
    });
};

export const replaceIdCaracter = (data) => {
  const rename = ({ _id: id, name: slotName, ...rest }) => ({
    id,
    slotName,
    ...rest,
  });
  let dataModfified = [];

  data.map((d) => dataModfified.push(rename(d)));

  return dataModfified;
};
